var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-maps-loader"},[_c('div',{ref:"googleMaps",staticClass:"google-maps-loader__placeholder"}),(Boolean(this.google) && Boolean(this.map))?[_vm._t("markers"),_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }